import httpApi from '@/apis/httpApi';

export interface Config {
  BASENAME: string;

  INITIAL_SELECTED: string;

  SUCCESS_REQUEST_LIST: string[];

  SUCCESS_CODE: number;

  ERROR_CODE: number[];

  AMEND_ERROR_CODE: number[];

  MESSAGE_ERROR_CODE: number[];

  LOGIN_EXPIRE: number[];

  REALNAME_CODE: number[];

  SPECIAL_CODE: number[];

  LOGIN_TYPE: string[];

  AIRE_TYPE: string[];

  API_URL: string;

  OLDSIGN_KEY: string;

  SIGN_KEY: string;

  TOKEN_KEY: string;

  layout: 'side' | 'top';

  theme: 'dark' | 'light';

  fixedHeader: boolean;

  contentWidth: 'fluid' | 'fixed';

  colorWeak: boolean;

  title: string;

  logo?: string;

  loginEvoke: boolean;

  isSignUp: boolean;

  SPECIFC_ROUTES: string[];

  loginReload: string;

  strWinId: string;

  voiceCommunityWinId: string;

  voiceCommunityGameWinId: string;

  voiceWinId: string;

  liveRaffleWinId: string;

  baseInfoWinId: string;

  serviceWinId: string;

  loginRouter: string;

  updaterRouter: string;

  cacheDate: number;

  outcCome: number;

  MEMBER_WINID: string;

  liveNoticeWinId: string;

  chatMsgNoticeWinId: string;

  MESSAGE_WINID: string;

  NOTICE_WINID: string;

  GAME_STATUS_NOTICE_WINID: string;
}

const SUCCESS_REQUEST_LIST: string[] = [httpApi.tradingBank.opinion];

const AdminConfig: Config = {
  BASENAME: '',

  INITIAL_SELECTED: '/home/homePage',

  // 请求成功根据接口返回所有数据
  SUCCESS_REQUEST_LIST,

  // 请求成功状态码
  SUCCESS_CODE: 200,

  // 请求失败状态码
  ERROR_CODE: [
    20017, 20045, 20010, 20015, 40001, 70003, 70046, 50001, 30001, 20004, 2380, 20009, 20063, 10003, 20014, 20060,
    81111, 81009, 50006, 50018, 20056, 40066, 70009, 70026, 70002, 70023, 70013, 70110, 70030, 70033, 98008, 20088,
    50007, 20090, 98005, 98107, 98002, 50002, 98007, 20039, 20090, 50037, 50038, 50035, 50036, 40073, 98208, 41033,
    40008, 60005, 32000, 32001, 32002, 32101, 32102, 98207, 70130, 70131, 60002, 60003, 60004, 60015, 45000, 10009,
    41027, 41037, 10006, 41026, 10004, 70111, 110002
  ],

  // 请求失败状态码
  AMEND_ERROR_CODE: [500],

  MESSAGE_ERROR_CODE: [400],

  // 登录过期，或者未登录
  LOGIN_EXPIRE: [400, 50008, 20038, 50010],

  // 需要实名
  REALNAME_CODE: [81111],

  // 导航栏层级修改
  AIRE_TYPE: ['/home/homePage', '/home/newSuit'],

  // 特殊状态码，不需要返回
  SPECIAL_CODE: [500],

  // 动态验签
  LOGIN_TYPE: ['/byPwd', '/byPhoneCode'],

  // 统一请求地址
  API_URL: '//managerapi-dev.dhsf.xqhuyu.com/api',

  // 本地存储token 的key
  TOKEN_KEY: 'Admin_Token_key',

  // 默认静态验签key
  OLDSIGN_KEY: '7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL',

  SIGN_KEY: '79e9a72c7d4611eebd1100163e381040',

  // 默认菜单栏位置
  layout: 'top',

  // 默认主题颜色
  theme: 'light',

  // 是否固定头部
  fixedHeader: false,

  // 固定宽度或者流式宽度
  contentWidth: 'fixed',

  // 是否开启色弱模式
  colorWeak: false,

  // 项目名称
  title: '996传奇盒子',

  // 登录唤起
  loginEvoke: false,

  // 登录窗口是否为登录
  isSignUp: false,

  // 是否为需要跳转路由
  SPECIFC_ROUTES: ['/competition/live'],

  // 重新登录刷新窗口
  loginReload: 'refrushReload',

  // 子窗口winId
  strWinId: 'LiveBroadcast',
  // 语音社区窗口winId
  voiceCommunityWinId: 'VoiceCommunityHome',
  // 语音社区游戏窗口winId
  voiceCommunityGameWinId: 'VoiceCommunityGameHome',
  // 语音窗口winId
  voiceWinId: 'VoiceHome',
  // 直播抽奖窗口winId
  liveRaffleWinId: 'LiveRaffleHome',
  // 开播提醒winId
  liveNoticeWinId: 'LiveNoticeHome',
  // 聊天提醒winId
  chatMsgNoticeWinId: 'ChatMsgNoticeHome',
  // 消息中心窗口winId
  baseInfoWinId: 'BaseInfoHome',
  // 区服客服窗口winId
  serviceWinId: 'serviceWinId',
  // 路由过滤
  loginRouter: 'login',
  // 更新消息窗口
  updaterRouter: 'updater',
  // 缓存刷新时间
  cacheDate: 10 * 60,
  // 获取当前时间
  outcCome: Math.round(new Date().getTime() / 1000),
  // 会员未激活子窗口
  MEMBER_WINID: 'memberWinId',
  // 消息客服
  MESSAGE_WINID: 'MESSAGEWINID',
  // 消息通知
  NOTICE_WINID: 'NOTICEWINID',
  // 游戏状态通知
  GAME_STATUS_NOTICE_WINID: 'GAME_STATUS_NOTICE_WINID'
};

export default AdminConfig;
